module.exports = {
      id: "socialshare-usage",
      viewBox: "0 0 23.63 25.957",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#socialshare",
      toString: function () {
        return this.url;
      }
    }